module.exports = __webpack_public_path__ + "img/top_conbadge.0cba8ee3.jpg";